import _ from 'lodash';
import Handlebars from 'handlebars';
import moment from 'moment';

const defaultTimezone = moment.tz.guess();

export function renderLocation(lat, long) {
  if (!lat || !long) return '';

  return new Handlebars.SafeString(
    `<div 
      style="cursor: pointer;" 
      class="show-map-marker" 
      data-lat=${lat} 
      data-long=${long}>
        At location [${lat.toFixed(6)}, ${long.toFixed(6)}] 
        <a target="_blank" href="https://www.google.com/maps/search/?api=1&query=${lat},${long}">Google Map</a>
      </div>`,
  );
}

export function lowerCase(text) {
  return text.toLowerCase();
}

export function upperCase(text) {
  return text.toUpperCase();
}

export function removeDash(text) {
  return text.replaceAll(['_'], '');
}

export function replaceDash(text) {
  return text.replaceAll(['_'], ' ');
}

export function convertMeterToMileString(val) {
  if (!val || isNaN(val)) return '';

  return `${convertMeterToMile(+val, 1)}`;
}

export function convertSecondToHour(val) {
  if (!val || isNaN(val)) return '';

  return secondToHour(+val);
}

export function capitalizeText(val) {
  if (!val) return '';

  return val.replace(/(^\w|\s\w)(\S*)/g, (_, m1, m2) => m1.toUpperCase() + m2.toLowerCase());
}

export function splitText(val, options) {
  if (!val) return '';
  const symbol = _.isEmpty(options?.hash && options.hash.symbol) ? ',' : options.hash.symbol;
  const valSplit = val.split(symbol);
  return !Array.isArray(valSplit) ? [] : valSplit.map((item) => item.trim());
}

export function formatDateTime(date, timezone, format) {
  const tz = timezone || defaultTimezone;

  if (!date) return '';

  return `${moment.tz(date, tz).format(format || `MM/DD/YYYY HH:mm z`)}`;
}

export function when(operand1, operator, operand2, options) {
  operator = operator || 'eq';

  const operators = {
    eq: (l, r) => {
      return l === r;
    },
    ne: (l, r) => {
      return l !== r;
    },
    gt: (l, r) => {
      return Number(l) > Number(r);
    },
    gte: (l, r) => {
      return Number(l) >= Number(r);
    },
    lt: (l, r) => {
      return Number(l) < Number(r);
    },
    lte: (l, r) => {
      return Number(l) <= Number(r);
    },
  };

  const result = operators[operator](operand1, operand2);

  if (result) return options.fn(this);
  else return options.inverse(this);
}

export function whenAnd(opts) {
  let isTrue = true;
  Object.keys(opts.hash).forEach((k) => {
    if (_.get(opts.data.root, k) !== opts.hash[k]) {
      isTrue = false;
    }
  });

  if (isTrue) return opts.fn(this);
  else return opts.inverse(this);
}

export function whenOr(opts) {
  let isTrue = false;
  Object.keys(opts.hash).forEach((k) => {
    if (_.get(opts.data.root, k) === opts.hash[k]) {
      isTrue = true;
    }
  });

  if (isTrue) return opts.fn(this);
  else return opts.inverse(this);
}

const secondToHour = (minute) => {
  if (!minute) return '';
  const duration = moment.duration(minute, 'seconds');

  //calculate hours
  const hh = duration.years() * (365 * 24) + duration.months() * (30 * 24) + duration.days() * 24 + duration.hours();

  //get minutes
  const mm = duration.minutes();
  if (hh === 0) return mm + 'mins';
  //return total time in hh:mm format
  return hh + 'hrs ' + mm + 'mins';
};

const MILE_TO_METER = 1609.34;
const convertMeterToMile = (val, decimal_number = 1) => {
  return (val / MILE_TO_METER).toFixed(decimal_number);
};

export const replaceText = (text, search, replace) => {
  // Replace all occurrences of `search` treated as a literal string. Using a
  // string argument (not a RegExp built from a variable) avoids ReDoS and keeps
  // regex metacharacters in `search` from being interpreted.
  return text.replaceAll(search, replace);
};

export function sum() {
  const args = [].concat.apply([], arguments);
  return _.sumBy(args, (arg) => {
    return !isNaN(arg) ? Number(arg) : 0;
  });
}

export function parseJSON(opts) {
  if (_.isNil(opts)) return '';

  return JSON.parse(typeof opts !== 'string' ? JSON.stringify(opts) : opts);
}

export function toJSON(opts) {
  if (_.isNil(opts)) return '';

  if (typeof opts === 'object') return JSON.stringify(opts);

  return opts;
}
